import {Auth} from '@aws-amplify/auth';
import {Account} from '../../accounts/types';
import {AccountSessionInfo} from '../types';

export const checkAccountSession = async (account: Account): Promise<AccountSessionInfo> => {
    try {
        Auth.configure({
            userPoolId: account.cognitoUserPoolId,
            userPoolWebClientId: account.appClientId,
        });

        const session = await Auth.currentSession();

        // Force a server-side validation — Auth.currentSession() only checks local token expiry
        // and won't detect tokens revoked by a global sign-out from the portal
        await Auth.currentAuthenticatedUser({ bypassCache: true });

        const idToken = session.getIdToken();
        const payload = idToken.payload;
        const tokenEmail = payload.email || payload['cognito:username'];
        const expiresAt = new Date(idToken.getExpiration() * 1000);
        const isExpired = Date.now() >= expiresAt.getTime();

        // Only mark as active if token matches this account (case-insensitive)
        const isActive = tokenEmail?.toLowerCase() === account.emailAddress?.toLowerCase();

        return {
            accountId: account.id,
            email: account.emailAddress,
            isActive,
            isExpired: isActive ? isExpired : true,
            expiresAt: isActive ? expiresAt : undefined,
            session: isActive && !isExpired ? session : undefined
        };
    } catch (error) {
        return {
            accountId: account.id,
            email: account.emailAddress,
            isActive: false,
            isExpired: true
        };
    }
};

export const checkMultipleAccountSessions = async (accounts: Account[]): Promise<AccountSessionInfo[]> => {
    const results: AccountSessionInfo[] = [];
    
    for (const account of accounts) {
        const info = await checkAccountSession(account);
        results.push(info);
    }
    
    return results;
};
